import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RolesNamesBE } from '../models/employee';
import { selectUserRoles } from '../store/profileSlice';

export interface UseUserRolesReturn {
  isAdmin: boolean;
  isTeamLead: boolean;
  isProjectManager: boolean;
  isBudgetOwner: boolean;
}

export function useUserRoles(): UseUserRolesReturn {
  const userRole = useSelector(selectUserRoles);

  const isAdmin = useMemo(
    () => userRole.some((el) => el.name === RolesNamesBE.ADMIN),
    [userRole]
  );

  const isTeamLead = useMemo(
    () => userRole.some((el) => el.name === RolesNamesBE.TEAM_LEAD),
    [userRole]
  );

  const isProjectManager = useMemo(
    () => userRole.some((el) => el.name === RolesNamesBE.PROJECT_MANAGER),
    [userRole]
  );

  const isBudgetOwner = useMemo(
    () => userRole.some((el) => el.name === RolesNamesBE.SALES_MANAGER),
    [userRole]
  );

  const values = useMemo(
    () => ({ isAdmin, isTeamLead, isProjectManager, isBudgetOwner }),
    [isAdmin, isBudgetOwner, isProjectManager, isTeamLead]
  );

  return values;
}
